import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  MapPin,
  Users,
  Package,
  Calendar,
  Star,
  Settings,
  LogOut,
  Globe,
  HelpCircle,
  Share2,
} from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import scotlandLogo from '../../assets/scotland-logo.png';

const Sidebar: React.FC = () => {
  const { user, logout, currentFlavourId, availableFlavours } = useAuth();

  const navigation = [
    { name: 'Dashboard', href: '/', icon: LayoutDashboard },
    { name: 'Apps', href: '/apps', icon: Globe },
    { name: 'Tours', href: '/tours', icon: MapPin },
    { name: 'Bundles', href: '/bundles', icon: Package },
    { name: 'Users', href: '/users', icon: Users },
    { name: 'Bookings', href: '/bookings', icon: Calendar },
    { name: 'Reviews', href: '/reviews', icon: Star },
    ...(user?.role === 'super_admin' ? [{ name: 'Admin Users', href: '/admin-users', icon: Users }] : []),
    { name: 'FAQ', href: '/faq', icon: HelpCircle },
    { name: 'Social', href: '/social', icon: Share2 },
    { name: 'Settings', href: '/settings', icon: Settings },
  ];

  const currentApp = availableFlavours.find(f => f.id === currentFlavourId);

  return (
    <div className="flex flex-col h-full bg-white border-r border-gray-200">
      {/* Logo */}
      <div className="flex items-center justify-center h-16 py-7 px-4 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <img
            src={scotlandLogo}
            alt="Scotland Tours"
            className="w-9 h-9 rounded-full shadow-sm"
          />
          <span className="text-xl font-bold text-primary-600">Scotland Tours</span>
        </div>
      </div>

      {/* Current App Display */}
      {/* {currentApp && (
        <div className="px-4 py-3 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <Globe className="w-4 h-4 text-primary" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900 truncate">
                {currentApp.name}
              </p>
              {currentApp.description && (
                <p className="text-xs text-gray-500 truncate">
                  {currentApp.description}
                </p>
              )}
            </div>
          </div>
        </div>
      )} */}

      {/* Navigation */}
      <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
        {navigation.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                `sidebar-item ${isActive ? 'sidebar-item-active' : ''}`
              }
            >
              <Icon className="h-5 w-5" />
              <span className="ml-3">{item.name}</span>
            </NavLink>
          );
        })}
      </nav>

      {/* User Info */}
      <div className="border-t border-gray-200 p-4">
        <div className="flex items-center space-x-3 mb-3">
        <div className="h-8 w-8 rounded-full bg-black flex items-center justify-center">
              <span className="text-sm font-medium text-white">
                {user?.firstName?.charAt(0) || user?.email?.charAt(0) || 'U'}
              </span>
            </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">
              {user?.firstName && user?.lastName 
                ? `${user.firstName} ${user.lastName}`
                : user?.email || 'User'
              }
            </p>
            <p className="text-xs text-gray-500 capitalize">
              {user?.role || 'Admin'}
            </p>
          </div>
        </div>
        
        <button
          onClick={logout}
          className="w-full flex items-center space-x-3 px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors"
        >
          <LogOut className="h-4 w-4" />
          <span>Sign Out</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar; 